export const formatHeights = heights => {
  const inFeet = heights.map(height => `${Math.floor(height / 12)}' ${height % 12}"`)
  return inFeet.join(', ')
}

export const formatPercent = decimal => {
  const { format } = new Intl.NumberFormat('en-US', { style: 'percent' })
  return format(decimal)
}
